import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  savedNotesContainer: {
    width: '100%',
    marginTop: 32,
  },
  savedNotesText: {
    color: '#3E4756',
    fontSize: 16,
    lineHeight: 24,
  },
  breakLine: {
    width: '100%',
    height: 1,
    marginTop: 12,
    backgroundColor: 'rgba(167, 177, 195, 0.6)',
    marginBottom: 10,
  },
  bottomContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  date: {
    color: '#828C9D',
    fontSize: 14,
    lineHeight: 17,
  },
  deleteNote: {
    color: '#D24E45',
    fontSize: 14,
    lineHeight: 17,
  },
})
